import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HLT from "../../../Images/thank-image.png";

const Thanks = () => {
    const location = useLocation(); // Correctly use useLocation hook
    const navigate = useNavigate();
    const policyData = location.state?.Data; // Safely access policyData

    console.log(policyData, "Policy Data");

    return (
        <div className="POS_Wrap ThanksPOS_Wrap">
            <div className="container">
                <section className="POS_WrapSec1 text-center">
                    <h1>Your claim request <span>submitted</span> !</h1>
                    <img src={HLT} style={{ width: "200px" }} alt="Thank You" />
                    <p>
                        Dear Customer,<br />
                        Your request has been submitted successfully. You will be contacted soon for further process.<br />
                        Reference ID: <strong>{policyData?.response?.refNumber || "Not Available"}</strong>
                    </p>
                    <p>
                        Thank you for trusting SMC. We assure you to provide the best services.
                    </p>
                    <button
                        className="newcRT d-block "
                        onClick={() => navigate("/cliam-intimation")}
                        role="button"
                    >
                        View Claim
                    </button>
                </section>
            </div>
        </div>

    );
};

export default Thanks;
